var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "entypo:suitcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6 4.79995H20.4V22.8H21.6C22.92 22.8 24 21.72 24 20.4V7.19995C24 5.87995 22.92 4.79995 21.6 4.79995ZM0 7.19995V20.4C0 21.72 1.0788 22.8 2.4 22.8H3.6V4.79995H2.4C1.0788 4.79995 0 5.87995 0 7.19995ZM16.2 2.28715C15.3828 1.90795 13.9332 1.19995 11.9772 1.19995C10.0176 1.19995 8.6172 1.90795 7.8 2.28715V4.79995H4.8V22.8H19.2V4.79995H16.2V2.28715ZM14.4 4.79995H9.6V3.19675C10.2408 2.92075 10.8936 2.63875 11.9772 2.63875C13.0596 2.63875 13.7604 2.91955 14.4 3.19675V4.79995Z",
    fill: "#545454"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.9b34924eb0b762ed5fd0ed6e02f84abf.svg";
export { ForwardRef as ReactComponent };